import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ResetPasswordCard from '../login/components/ResetPasswordCard';
import { auth } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { useAppConfig } from '../../lib/AppConfigContext';

const PasswordResetPage = () => {
  const { config } = useAppConfig();
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      if (u) {
        navigate('/', { replace: true });
      }
    });

    document.title = `Reset Password - ${config?.branding?.appName || 'GoldBuy Portal'}`;

    return () => {
      document.title = config?.branding?.appName || 'GoldBuy Portal';
      unsub && unsub();
    };
  }, [navigate, config]);

  return (
    <div className="flex min-h-screen flex-col bg-[#F5F6F8] text-[#17191D]">
      <main className="flex flex-1 items-center justify-center px-4 py-6 sm:px-8 sm:py-12">
        <section className="grid w-full max-w-[1000px] overflow-hidden rounded-2xl border border-[#DCDFE5] bg-white md:grid-cols-[0.9fr_1.1fr]">
          <aside className="flex flex-col justify-between gap-8 bg-[#17191D] p-6 text-white sm:p-10 md:min-h-[560px] md:p-12">
            <div className="flex items-center gap-3">
              <img src="/brand/logo-transparent.png" alt={config?.branding?.shortName || 'GoldBuy'} className="h-12 w-12 shrink-0 object-contain" />
              <p className="text-sm font-medium tracking-tight">{config?.branding?.appName || 'GoldBuy Portal'}</p>
            </div>
            <div className="hidden md:block">
              <p className="mb-5 text-xs font-medium uppercase tracking-[0.14em] text-[#A9AFBA]">Account recovery</p>
              <h2 className="text-[42px] font-semibold leading-[1.1] tracking-[-0.04em]">Back to your<br />workspace.</h2>
              <p className="mt-5 max-w-[260px] text-sm leading-6 text-[#B9BEC8]">Reset your account password using your email address.</p>
            </div>
            <p className="hidden border-t border-white/15 pt-6 text-xs leading-5 text-[#A9AFBA] md:block">Need help with access?<br />Contact your administrator.</p>
          </aside>
          <ResetPasswordCard />
        </section>
      </main>
      <footer className="px-4 pb-6 text-center text-xs text-[#656C78]">
        © {new Date().getFullYear()} {config?.branding?.shortName || 'GoldBuy'}
      </footer>
    </div>
  );
};

export default PasswordResetPage;
